import * as types from "../../types/travel";
import axios from "axios";

const token = localStorage.getItem("token:key");
const URL = `/api/v1/travel`;

//////////////////////////////////////////////
//////////////// Visa Application ////////////
//////////////////////////////////////////////
export const createVISA = (body) => async (dispatch) => {
    try {
        console.log(body)
        dispatch({
            type: types.CREATE_VISA_REQUEST,
        });
        const { data } = await axios.post(`${URL}/visa`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.CREATE_VISA,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.CREATE_VISA_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const submitVISA = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.SUBMIT_VISA_REQUEST,
        });
        const { data } = await axios.put(`${URL}/visa/submit/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.SUBMIT_VISA,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.SUBMIT_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const updateVISA = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.UPDATE_VISA_REQUEST,
        });
        const { data } = await axios.put(`${URL}/visa/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.UPDATE_VISA,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.UPDATE_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const deleteVISA = (id) => async (dispatch) => {
    try {
        dispatch({
            type: types.DELETE_VISA_REQUEST,
        });
        await axios.delete(`${URL}/visa/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.DELETE_VISA,
            payload: id,
        });
    } catch (error) {
        dispatch({
            type: types.DELETE_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getVISAs = () => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_VISAS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/visa`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_VISAS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: types.GET_VISAS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getVISA = (id) => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_VISA_REQUEST,
        });
        const { data } = await axios.get(`${URL}/visa/${id}/single`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_VISA,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: types.GET_VISA_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const approveVISA = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.APPROVE_VISA_REQUEST,
        });
        const { data } = await axios.put(`${URL}/visa/approve/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.APPROVE_VISA,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.APPROVE_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const rejectVISA = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.REJECT_VISA_REQUEST,
        });
        const { data } = await axios.put(`${URL}/visa/reject/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.REJECT_VISA,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.REJECT_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const acceptVISA = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.ACCEPT_VISA_REQUEST,
        });
        const { data } = await axios.put(`${URL}/visa/accept/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.ACCEPT_VISA,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.ACCEPT_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const declineVISA = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.DECLINE_VISA_REQUEST,
        });
        const { data } = await axios.put(`${URL}/visa/decline/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        
        dispatch({
            type: types.DECLINE_VISA,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.DECLINE_VISA_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};
